<form [formGroup]="pricingForm" class="form was-validated">
  <ix-typography format="h3">Pricing</ix-typography>
  <ix-layout-grid class="layout-grid-form" gap="12">
    @if (pricingForm.controls[fields.SIMPLE_CALC].value !== 'MLFB') {
      <ix-row>
        <ix-col size="2" size-sm="12">
          <label class="tooltip-Contractduration" aria-describedby="tooltip-Contractduration">Contract Duration</label>
          <ix-tooltip id="tooltip-Contractduration" for=".tooltip-Contractduration">{{
            pricingForm.controls[fields.CONTRACT_DURATION_TOOLTIP].value
          }}</ix-tooltip>
        </ix-col>
        <ix-col>
          <ix-select
            class="ix-select input-width"
            name="ix-select-control"
            [formControlName]="fields.CONTRACT_DURATION"
          >
            @for (option of dropdowns[fields.CONTRACT_DURATION]; track option) {
              <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
            }
          </ix-select>
        </ix-col>
      </ix-row>
    }
    <ix-row>
      <ix-col size="2" size-sm="12">
        <label class="tooltip-typeofpricing" aria-describedby="tooltip-typeofpricing">Type of Pricing</label>
        <ix-tooltip id="tooltip-typeofpricing" for=".tooltip-typeofpricing">{{
          pricingForm.controls[fields.TYPE_OF_PRICING_TOOLTIP].value
        }}</ix-tooltip>
      </ix-col>
      <ix-col>
        <ix-select class="ix-select input-width" name="ix-select-control" [formControlName]="fields.TYPE_OF_PRICING">
          @for (option of dropdowns[fields.TYPE_OF_PRICING]; track option) {
            <ix-select-item label="{{ option.label }}" value="{{ option.value }}"> </ix-select-item>
          }
        </ix-select>
      </ix-col>
    </ix-row>
    @if (
      pricingForm.controls[fields.CONTRACT_DURATION].value > 1 &&
      pricingForm.controls[fields.SIMPLE_CALC].value !== 'MLFB'
    ) {
      <ix-row>
        <ix-col size="2" size-sm="12">
          <label class="tooltip-indexation" aria-describedby="tooltip-indexation">Indexation</label>
          <ix-tooltip id="tooltip-indexation" for=".tooltip-indexation">{{
            pricingForm.controls[fields.INDEXATION_TOOLTIP].value
          }}</ix-tooltip>
        </ix-col>
        <ix-col>
          <ix-number-input
            [formControlName]="fields.INDEXATION"
            min="0"
            pattern="[0-9]*[.,]?[0-9]{1,2}"
            [invalidText]="validationFeedback.negativeNumber"
          >
            <ix-typography slot="end">%</ix-typography>
          </ix-number-input>
        </ix-col>
      </ix-row>
      <ix-row>
        <ix-col size="2" size-sm="12">
          <label class="tooltip-activatediscount" aria-describedby="tooltip-activatediscount">Activated Discount</label>
          <ix-tooltip id="tooltip-activatediscount" for=".tooltip-activatediscount">{{
            pricingForm.controls[fields.ACTIVATE_DISCOUNT_TOOLTIP].value
          }}</ix-tooltip>
        </ix-col>
        <ix-col>
          <ix-select
            class="ix-select input-width"
            name="ix-select-control"
            [formControlName]="fields.ACTIVATE_DISCOUNT"
          >
            @for (option of dropdowns[fields.ACTIVATE_DISCOUNT]; track option) {
              <ix-select-item label="{{ option.value }}" value="{{ option.value }}"> </ix-select-item>
            }
          </ix-select>
        </ix-col>
      </ix-row>
      <ix-row>
        <ix-typography class="disclaimer" bold="true">
          {{ pricingForm.controls[fields.INDEX_DISCLAIMER].value }}
        </ix-typography>
      </ix-row>
    }
  </ix-layout-grid>

  <div class="button-container">
    <ix-button variant="subtle-primary" class="m-1 back-button" (click)="stepBack()">Back</ix-button>
    <ix-button variant="primary" class="next-button" (click)="nextStep()">Next</ix-button>
  </div>
</form>
